import { capitalize } from 'underscore.string';

import UserLink from 'src/modules/shared/links/userLink';
import Badge from 'src/components/badge';
import MemberTags from 'src/components/memberTags';

import i18n from 'src/utils/translate';
import { Element, Section } from 'src/constants/footfall';
import CommunityMemberCardMenu from 'src/modules/community/communityMembers/communityMemberCardMenu';
import { CommunityMember } from 'src/constants/types';
import { Size } from 'src/components/avatar';

type Props = {
  member: CommunityMember;
  isOnTwoColumns?: boolean;
  onMemberCardClick?: (username: string) => void;
}
export default function CommunityMemberCard({ isOnTwoColumns = false, member, onMemberCardClick = () => {} }: Props): JSX.Element {
  const {
    age,
    bio,
    country,
    gender,
    profileImageSmall2x,
    roles,
    username,
    healthInterests,
  } = member;
  const parsedBio = bio && bio.replace(/[\b\t\n\f\r]/g, ' ').trim();

  return (
    <div className={isOnTwoColumns ? 'base-card-wider' : 'base-card'}>
      <div className="base-card__inner community-member-card__inner" data-testid="base-card-inner">
        <div className="community-member-card__header">
          <UserLink
            avatarSize={Size.Medium}
            className="community-member-card__avatar"
            signupContext={{
              element: Element.AVATAR,
              section: Section.COMMUNITY_MEMBERS,
            }}
            user={{
              username,
              profileImageSmall: profileImageSmall2x,
            }}
            onClick={() => onMemberCardClick(username)}
          />

          <div className="community-member-card__username">
            <UserLink
              className="community-member-card__user-link"
              signupContext={{
                element: Element.USER_LINK,
                section: Section.COMMUNITY_MEMBERS,
              }}
              user={{ username }}
              onClick={() => onMemberCardClick(username)}
            />
            {roles?.length > 0 && (
              <Badge className="community-member-card__badge">
                {roles[0]}
              </Badge>
            )}
          </div>

          <CommunityMemberCardMenu member={member} />
        </div>

        <div className="community-member-card__meta">
          { !!gender && <span>{capitalize(gender)}</span> }
          { !!age && <span>{`${age} ${i18n.t('years old')}`}</span> }
          { !!country && <span>{country}</span> }
        </div>

        <p className="community-member-card__bio">{parsedBio}</p>

        { healthInterests && healthInterests.length > 0 &&
          <MemberTags tags={healthInterests} username={username}/>
        }
      </div>
    </div>
  );
}
